import { HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { PxlHttpResponseError } from '@pxl/models/common';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const errorInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
    return next(req).pipe(
        catchError((error) => {
            if (error instanceof HttpErrorResponse) {
                return throwError(
                    () =>
                        new PxlHttpResponseError(
                            {
                                error: error.error,
                                headers: error.headers,
                                status: error.status,
                                statusText: error.statusText,
                                url: error.url ?? undefined,
                            },
                            req,
                        ),
                );
            }
            return throwError(() => error);
        }),
    );
};
